// extracted by mini-css-extract-plugin
module.exports = {"answer":"Answer_answer__2TbRd","checkboxInput":"Answer_checkboxInput__3x55D"};